import { HfsSettingsActionEnum } from 'fleet-data-model';
import { type Update } from '../../types';

export const mapFairwayCuttingExecutionTargets = (update: Update) => {
  return [
    {
      hfsActionId: HfsSettingsActionEnum.FAIRWAY_CUTTING_ENABLED,
      iprId: update.assetId,
      payload: {
        enabled: update.enabled,
      },
    },
  ];
};
